<template>
    <a-modal :visible="editorModalVisible" :confirm-loading="confirmLoading" width="580px" @cancel="handleCancel" :footer="null"
                title="编辑执行器">

         <a-form-model :model="modalData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="appname" label="AppName" prop="appname">
                    <a-input v-model="modalData.appname"/>
                </a-form-model-item>

                <a-form-model-item ref="title" label="名称" prop="title">
                    <a-input v-model="modalData.title"/>
                </a-form-model-item>

                <a-form-model-item ref="addressType" label="注册方式" prop="addressType">
                    <a-radio-group v-model="modalData.addressType">
                      <a-radio :value="0">自动注册</a-radio>
                      <a-radio :value="1">手动录入</a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="addressList" label="机器地址" prop="addressList">
                    <a-input type="textarea" style="height:200px;" placeholder="请输入执行器地址列表，多地址逗号分隔" :readOnly="modalData.addressType == 0" v-model="modalData.addressList"/>
                </a-form-model-item>
               
                <a-form-model-item :wrapper-col="{ span: 8, offset: 10 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
    </a-modal>
</template>

<script>
export default{
    data(){
        return {
            editorModalVisible:false,
            confirmLoading:false,  
            labelCol: { span: 6 },
            wrapperCol: { span:16 },
            formItemLayout:'horizontal',
            modalData:{
                id:'',
                appname:'',
                title:'',
                addressType:0,
                addressList:'',
                registryList:[]
            },
            rules: {
                appname: [
                    { required: true, message: '请输入AppName', trigger: 'blur' },
                    { min: 4, max: 64, message: '请输入4~64个字符', trigger: 'blur' },
                ],
                title:[
                    { required: true, message: '请输入名称', trigger: 'blur' },
                    { min: 4, max: 12, message: '请输入4~12个字符', trigger: 'blur' },
                ],
                addressList:[
                    { required: true, message: '请输入机器地址', trigger: 'blur' },
                    { min: 1, max: 1000, message: '请输入1~1000个字符', trigger: 'blur' },
                ],
            },
        }
    },
    methods:{
        init(item){
            if(item.id){
                this.modalData.id = item.id;
                this.modalData.appname = item.appname;
                this.modalData.title = item.title;
                this.modalData.addressType = item.addressType;
                this.modalData.addressList = item.addressList;
                this.modalData.registryList = item.registryList;
            }
            else{
                this.modalData = {
                    id:undefined,
                    appname:'',
                    title:'',
                    addressType:0,
                    addressList:'',
                    registryList:[]
                }
            }

            this.editorModalVisible = true;
        },
        handleOk() {
            let that = this;
            that.modalData.registryList = that.modalData.addressList.split(',')
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    //处理list
                    if(that.modalData.id){
                        //编辑
                        that.$store.dispatch({
                            type: 'jobcenter/editJobGroup',
                            params: {
                                ...that.modalData,
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.code == 200) {
                                that.message.success('操作成功')
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                            else{
                                that.message.error(res.data.msg || '操作失败')
                            }
                        });
                    }
                    else {
                        //新增
                        that.$store.dispatch({
                            type: 'jobcenter/addJobGroup',
                            params: {
                                ...that.modalData,
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.code == 200) {
                                that.message.success('操作成功')
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                            else{
                                that.message.error(res.msg || '操作失败')
                            }
                        });
                    }
                    console.log(that.modalData)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.editorModalVisible = false;
            
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    }
}
</script>